import React, { useState, useEffect } from 'react';
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import moment from 'moment';

const VacationList = ({ refresh, users, editFunc, delFunc }) => {
    let [recs, setRecs] = useState([]);




    useEffect(() => {
        Comm.Instance().get(`vacation`)
            .then(result => {
                setRecs(result.data);

            }).catch(error => Tools.ProcessError(error));
    }, [refresh]);

    const getUserName = (un) => {
        let u = users.find(x => x.username === un);
        if (!u)
            return un;
        else
            return u.fullname;
    }

   

    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th>Служител</th>
                    <th>Заместващ</th>
                    <th>От дата</th>
                    <th>До дата</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {
                    recs.map((i, ix) =>
                        <tr key={ix}>
                            <td><button className="btn btn-link" onClick={() => editFunc(i)}>{getUserName(i.who)}</button></td>
                            <td>{getUserName(i.replace)}</td>
                            <td>{moment(i.fromDate).format("DD-MM-YYYY")}</td>
                            <td>{moment(i.toDate).format("DD-MM-YYYY")}</td>
                            <td><button className="btn btn-danger" onClick={() => delFunc (i.vacationId)}>X</button></td>
                        </tr>
                    )
                }
            </tbody>
        </table>

    );
}


export default VacationList;

